//Util.ts =================================================
import "../Util/Prototypes";

import * as Settings from "../Settings";
import * as Util from "./Util";

//Get window height.
export function windowHeight(): number {
   const h: number = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
   return h;
}

//Get window width.
export function windowWidth(): number {
   const w: number = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
   return w;
}

//Difference in months between two dates.
export function dateDiffInMonths(a: Date, b: Date): number {
   const msPerMonth = 1000 * 60 * 60 * 24 * 30.4;
   const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
   const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());
   return Math.floor((utc1 - utc2) / msPerMonth);
}

//Convert short date string to YYYY-MM-DD.
export function shortDateToYMD(str: string): string {
   const sa: string[] = str.split("/");
   sa[0] = ('00' + sa[0]).slice(-2);
   sa[1] = ('00' + sa[1]).slice(-2);
   const s: string = sa[2] + "-" + sa[0] + "-" + sa[1];
   return s;
}

//Get unique id.
export function uid(): string {
   return ("id" + Math.random().toString(36).slice(2));
}

export function errMsg(msg: string, obj?) {
   if (console.error) {
      const prefix: string = "WGS - ";
      if (obj) {
         console.error(prefix + msg, obj);
      } else {
         console.error(prefix + msg);
      }
   }
   if (Settings.showAlertMessages) {
      alert("Error: " + msg);
   }
}

export function logMsg(msg: string, obj?) {
   if (console.log && Settings.verboseLogging) {
      const prefix: string = "WGS - ";
      if (obj) {
         console.log(prefix + msg, obj);
      } else {
         console.log(prefix + msg);
      }
   }
}

//Round to specified number of decimals and return number. Default is round to whole number.
export function round(num_or_str: string | number, numDecimals: number = 0): number {
   let outNum: number = 0;

   if (num_or_str) {
      if (typeof num_or_str === "string") {
         outNum = parseFlt(parseFlt(num_or_str).toFixed(numDecimals));
      } else {
         outNum = parseFlt(num_or_str.toFixed(numDecimals));
      }
   }

   return outNum;
}

//Get querystring argument.
export function getQueryString(name: string, upTop: boolean = false): string {
   let nv: string[];
   let qsValue: string = null;

   let qs: string = document.location.search.substring(1);
   if (upTop) {
      qs = top.document.location.search.substring(1);
   }

   const pairs: string[] = qs.split("&");

   for (const pair of pairs) {
      nv = pair.split("=");
      if (nv[0].Equal(name)) {
         qsValue = decodeURIComponent(nv[1]);
      }
   }
   return qsValue;
}

//Get page url.
export function getPageURL(): string {
   let url: string = top.window.location.href;

   let pos: number = url.indexOf("?");
   if (pos !== -1) {
      url = url.SubStr(0, pos);
   }

   pos = url.indexOf("#");
   if (pos !== -1) {
      url = url.SubStr(0, pos);
   }
   return url;
}

//Format a field value.
export function formatTextValue(fieldValue: string | number | Date, formatType: string, removeTrailZero: boolean = false): string {
   if (fieldValue === null) {
      return "";
   }

   let outVal = fieldValue.toString();
   let numValue = 0;

   if (typeof fieldValue === "string") {
      numValue = parseFlt(fieldValue);

   } else if (typeof fieldValue === "number") {
      numValue = fieldValue;
   }

   //Process all format types.
   if (formatType === "Acres") {
      outVal = (numValue / 43560).toFixed(2);

   } else if (formatType === "SqFt") {
      outVal = (numValue * 43560).toFixed(1);

   } else if (formatType === "Round0") {
      outVal = Util.round(numValue, 0).toString();

   } else if (formatType === "Round1") {
      outVal = Util.round(numValue, 1).toString();

   } else if (formatType === "Round2") {
      outVal = Util.round(numValue, 2).toString();

   } else if (formatType === "Round3") {
      outVal = Util.round(numValue, 3).toString();

   } else if (formatType === "Round4") {
      outVal = Util.round(numValue, 4).toString();

   } else if (formatType === "Round5") {
      outVal = Util.round(numValue, 5).toString();

   } else if (formatType === "MixedCase") {
      outVal = outVal.ToProperCase();

   } else if (formatType === "ShortDate" || formatType === "DateTime") {
      if ((typeof fieldValue === "object") && (fieldValue instanceof Date)) {

         if (fieldValue.toString() === "Invalid Date") {
            outVal = "";

         } else if (formatType === "ShortDate") {
            outVal = fieldValue.ToShortDate();

         } else if (formatType === "DateTime") {
            outVal = fieldValue.toLocaleString();
         }
      }

   } else if (formatType === "Comma") {
      outVal = Util.formatCurrency(numValue).replace("$", "");

      if (removeTrailZero && outVal.indexOf(".") !== -1) {
         if (outVal.EndsWith("0")) {
            outVal = outVal.SubStr(0, outVal.length - 1);
         }
      }

   } else if (formatType === "Money") {
      outVal = Util.formatCurrency(numValue);

   } else if (formatType === "IntToDateStr") {
      outVal = Util.intToDateStr(numValue);
   }

   return outVal;
}

//Convert number yyyymmdd to date string "mm/dd/yyyy".
export function intToDateStr(int: string | number): string {
   let s = "";

   if (int) {
      if (typeof int === "number") {
         s = int.toString();
      } else {
         s = int;
      }

      if (s.length === 8) {
         s = s.SubStr(4, 2) + "/" + s.SubStr(6, 2) + "/" + s.SubStr(0, 4);
      }
   }
   return s;
}

//Parse float.
export function parseFlt(str: string): number {
   let outVal = parseFloat(str);
   if (isNaN(outVal)) {
      outVal = 0;
   }
   return outVal;
}

//Parse integer.
export function parseInteger(str: string): number {
   let outVal: number = parseInt(str, 10);
   if (isNaN(outVal)) {
      outVal = 0;
   }
   return outVal;
}

//Sort array of class objects. Usage: myClassArray.sort(Util.sortArray("My_Property_Name"));
export function sortArray(property: string) {
   return function (a, b) {
      return (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
   };
}

export function sortArray_reverse(property: string) {
   return function (a, b) {
      return (a[property] > b[property]) ? -1 : (a[property] < b[property]) ? 1 : 0;
   };
}

//Convert to boolean.
export function cBool(str: string): boolean {
   switch (String(str).toLowerCase()) {
      case "true":
      case "t":
      case "1":
      case "yes":
      case "y":
         return true;
      default:
         return false;
   }
}

//Set size based on browser window size.
//export function SetSizeByBrowserSize(obj, ht_minus, wd_minus) {
//   obj.height(Browser.Height - ht_minus);
//   if (wd_minus) {
//      obj.width(Browser.Width - wd_minus);
//   }
//};

//Format currency value.
export function formatCurrency(in_num: number): string {
   if (isNaN(in_num)) {
      return "$0";
   }
   const formattedNumber = in_num.toFixed(2); //Ensure two digits after the decimal point.

   // Add commas for thousands and beyond.
   const parts = formattedNumber.split(".");
   parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");

   // Combine the integer part and the decimal part.
   const result = parts.join(".").replace(".00", "");

   return "$" + result;
}

//Is HTML5 date string supported
export function isDateInputSupported(): boolean {
   const elem = document.createElement('input');
   elem.setAttribute('type', 'date');
   elem.value = 'foo';
   return (elem.type === 'date' && elem.value !== 'foo');
}

//Is valid date string.
export function isDateStr(str: string): boolean {
   const d = new Date(str);
   if (Object.prototype.toString.call(d) === "[object Date]") {
      if (isNaN(d.getTime())) {
         return false;
      } else {
         return true;
      }

   } else {
      return false;
   }
}

//Download csv file.
export function downloadCSV(fileName: string, csv: BlobPart): void {
   const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });

   //   if (navigator.msSaveBlob) { //IE 11.
   //      navigator.msSaveBlob(blob, fileName);

   //   } else {
   const link = document.createElement("a");

   if (link.download !== undefined) { //Make sure download is available.
      const url: string = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", fileName);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
   }
   //   }
}

//Download zip file.
export function downloadZip(fileName: string, url: string): void {
   const link = document.createElement("a");
   link.download = fileName;
   link.href = 'data:application/x-zip-compressed,' + url;
   document.body.appendChild(link);
   link.click();
   document.body.removeChild(link);
}
